import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Modal} from 'react-bootstrap';
// Helpers de formulário
import InputMask from 'react-input-mask';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class TrainingAlertsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      alert_id: '',
      comment: '',
      training_id: this.props.training_id,
      alert_comments: [],
    };
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.deletarLinhaModal = this.deletarLinhaModal.bind(this);
    this.deletarModal = this.deletarModal.bind(this);
    this.botaoDeletarModal = this.botaoDeletarModal.bind(this);
    this.addComment = this.addComment.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.alerts)) || (this.state.loaded === 1 && newProps.updated === 1)){
      this.setState({
        training_id: newProps.training_id,
        alerts: newProps.alerts,
        loaded: 1,
      });
    }
  }
  showModal(event) {
    /**
     * busco dados para exibição no modal
     */
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/alerta/comentarios/'+event.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            alert_comments: responseJson.data,
            alert_id: event.id,
            alert: event.title,
            modal: true,
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  addComment(event) {
    event.preventDefault();

    var dados_salvar = {
      alert_id: this.state.alert_id,
      message: this.state.comment,
    };
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/alerta/comentario', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var dados_temp = self.state.alert_comments;
          dados_temp.push(responseJson.data);
          self.setState({alert_comments: dados_temp});        
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  deletarModal (event) {
    var alert_comment_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabAlertas.deletarComentario);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/alerta/comentario/' + alert_comment_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinhaModal(alert_comment_id);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  deletarLinhaModal(alert_comment_id) {
    var dados = this.state.alert_comments;
    dados.map(function(dado, index){
      if (dado.id == alert_comment_id) {
        dados.splice(index, 1);
      }
    });
  }
  ActionsButtons (cell, row) {
    var botao = (
      <button className="btn btn-primary btn-sm" onClick={() => { this.showModal(row); }}>
        <i className="fa fa-fw fa-pencil"></i>
      </button>
    );

    return botao;
  }
  botaoDeletarModal (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletarModal}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tituloListaDeAlertas}</h3>
  <hr/>
  <BootstrapTable data={this.state.alerts} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.semAlertas}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.Tipo}</TableHeaderColumn>
    <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.Tripulante}</TableHeaderColumn>
    <TableHeaderColumn dataField="role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.Cargo}</TableHeaderColumn>
    <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.Aula}</TableHeaderColumn>
    <TableHeaderColumn dataField="title" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.Titulo}</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaListaDeAlertas.Acoes}</TableHeaderColumn>

  </BootstrapTable>
  <Modal show={this.state.modal} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
    <h4 className="pull-left">{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tituloAdicionarComentarioNesteAlertaDeTreinamento}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.addComment}>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.formulario.Comentario}:</label>
              <input type="text" name="comment" className="form-control" placeholder="" value={this.state.comment} onChange={this.handleChange.bind(this, 'comment')} />
            </div>     
          </div>
        </div>
        <div className="form-group">
          <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> {this.locale.Treinamentos.EditarTreinamento.tabAlertas.formulario.botaoAdicionarComentario}</button>
        </div>
      </form>
      <hr/>
      <h4>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tituloComentariosSobreOAlerta}:</h4>
      <hr/>
      <BootstrapTable data={this.state.alert_comments} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaComentariosSobreOAlerta.semComentarios}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="message" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaComentariosSobreOAlerta.Comentario}</TableHeaderColumn>

        <TableHeaderColumn dataField="user_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaComentariosSobreOAlerta.Usuario}</TableHeaderColumn>

        <TableHeaderColumn dataField="created_at" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaComentariosSobreOAlerta.Data}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletarModal} width='80'>{this.locale.Treinamentos.EditarTreinamento.tabAlertas.tabelaComentariosSobreOAlerta.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default TrainingAlertsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingAlertsTab.js